import cn from "classnames"

import { SvgIcon } from "@components/common"

import useReactions, { VOTE_OPTIONS } from "pages/TeeUpPage/TeeUpPageContext/useReactions"

import "./index.scss"

interface Props {
  suggestionId: string | number
}

// FIX(11-R1): count-free react affordance for suggestions. QJ 2026-07-03: reacting to When/Where
// suggestions is core group-resolution behavior -- any participant (no organizer gate) must be able
// to react and see who else reacted. Standing rule: no numeric tallies, no vote wording, no
// "Decided" badge -- icon-only thumb-up/thumb-down toggles, your own vote renders filled/highlighted,
// nobody's count is ever shown here (the roster of who-reacted lives in the Reactions tab, which is
// already count-free -- see molecules/Reactions/index.tsx). Reuses the existing useReactions hook
// (pages/TeeUpPage/TeeUpPageContext/useReactions.js, already wired for BUG-020 toggle/switch
// semantics: tap same vote again removes it, tap the other vote switches) which was already consumed
// by GamePlanCard.js but had no equivalent affordance inside the suggestion popup itself.
const ReactToggle = ({ suggestionId }: Props) => {
  const { userVote, onUpVote, onDownVote } = useReactions(suggestionId)

  const isUpVoted = userVote === VOTE_OPTIONS.upVote
  const isDownVoted = userVote === VOTE_OPTIONS.downVote

  return (
    <div className="react-toggle" onClick={e => e.stopPropagation()}>
      <button
        type="button"
        className={cn("react-toggle__btn", {
          "react-toggle__btn--active": isUpVoted,
        })}
        onClick={onUpVote}
        aria-label="Thumbs up"
        aria-pressed={isUpVoted}>
        <SvgIcon name={isUpVoted ? "thumb-up-filled" : "thumb-up"} />
      </button>
      <button
        type="button"
        className={cn("react-toggle__btn", {
          "react-toggle__btn--active": isDownVoted,
        })}
        onClick={onDownVote}
        aria-label="Thumbs down"
        aria-pressed={isDownVoted}>
        <SvgIcon name={isDownVoted ? "thumb-down-filled" : "thumb-down"} />
      </button>
    </div>
  )
}

export default ReactToggle
